export const DEFAULT_IMAGE_URL = 'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?auto=format&fit=crop&w=1400&q=75';

const UNSPLASH_HOSTS = new Set(['images.unsplash.com']);
const PEXELS_HOSTS = new Set(['images.pexels.com']);

export function getOptimizedImageUrl(src, { width = 1200, quality = 75 } = {}) {
  if (!src || typeof src !== 'string') {
    return DEFAULT_IMAGE_URL;
  }

  try {
    const url = new URL(src);
    const host = url.hostname.toLowerCase();

    if (UNSPLASH_HOSTS.has(host)) {
      url.searchParams.set('auto', 'format');
      url.searchParams.set('fit', 'crop');
      url.searchParams.set('w', String(width));
      url.searchParams.set('q', String(quality));
      return url.toString();
    }

    if (PEXELS_HOSTS.has(host)) {
      url.searchParams.set('auto', 'compress');
      url.searchParams.set('cs', 'tinysrgb');
      url.searchParams.set('w', String(width));
      return url.toString();
    }

    return url.toString();
  } catch (error) {
    return DEFAULT_IMAGE_URL;
  }
}